import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { Cookie } from "lucide-react";

const KEY = "ilakeit-cookie-consent";

const setConsent = (value) => {
  try { localStorage.setItem(KEY, value); } catch (e) { console.error("Cookie consent: localStorage write failed:", e); }
  try {
    if (window.posthog) {
      if (value === "accepted") window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) { console.error("Cookie consent: PostHog update failed:", e); }
  // Google Analytics 4 — Consent Mode v2
  try {
    if (window.gtag) {
      const granted = value === "accepted" ? "granted" : "denied";
      window.gtag("consent", "update", {
        ad_storage: granted,
        ad_user_data: granted,
        ad_personalization: granted,
        analytics_storage: granted,
      });
    }
  } catch (e) { console.error("Cookie consent: GA4 consent update failed:", e); }
};

export const CookieBanner = () => {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let choice = null;
    try { choice = localStorage.getItem(KEY); } catch (e) { console.error("Cookie consent: localStorage read failed:", e); }
    if (!choice) setVisible(true);
    else if (choice === "rejected") { try { window.posthog && window.posthog.opt_out_capturing(); } catch (e) { console.error("Cookie consent: PostHog opt-out failed:", e); } }
  }, []);

  if (!visible) return null;

  const decide = (value) => { setConsent(value); setVisible(false); };

  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-5 left-5 right-5 sm:right-auto z-[70] max-w-md bg-white rounded-2xl shadow-2xl shadow-black/20 border border-black/5 p-5">
      <div className="flex items-start gap-3">
        <span className="flex-shrink-0 w-10 h-10 rounded-full bg-[#1D3557]/10 flex items-center justify-center">
          <Cookie className="w-5 h-5 text-[#1D3557]" />
        </span>
        <div>
          <p className="text-sm text-[#1A1A1A] leading-relaxed">
            {t("cookie.text")}{" "}
            <Link to={`/${lang}/privacy`} data-testid="cookie-privacy-link" className="text-[#1D3557] underline underline-offset-2 hover:text-[#345B73]">
              {t("cookie.privacy")}
            </Link>
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button data-testid="cookie-accept" onClick={() => decide("accepted")}
              className="px-4 py-2 rounded-full bg-[#1D3557] text-white text-sm font-medium hover:bg-[#345B73] transition-all">
              {t("cookie.accept")}
            </button>
            <button data-testid="cookie-reject" onClick={() => decide("rejected")}
              className="px-4 py-2 rounded-full border border-black/15 text-[#1A1A1A] text-sm font-medium hover:bg-black/5 transition-all">
              {t("cookie.reject")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
